import { StyleSheet } from 'react-native';
import { COLORS } from './colors';

const textColor = COLORS.GREEN;

export const TEXT_STYLES = StyleSheet.create({});
